﻿import { Directive } from "@app/components/directive";
import { StateService } from "@uirouter/angularjs";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";
import { IRootScope } from "@models";

@NgComponent({
    token: Token.KbMenu,
    dependencies: [
        Token.KbService,
        Token.$RootScope,
        Token.$State,
    ]
})
export class KbMenu extends Directive {
    constructor(
        private kbService: KbService,
        $rootScope: IRootScope,
        $state: StateService
    ) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-menu");
        this.scope = true;
        this.replace = true;
        this.transclude = true;

        this.link = (scope, element, atts) => {

        };
    }
}
